import { useEffect } from 'react';

/**
 * Registers a click/tap outside the provided element (ref) and executes the handler
 * An optional array of exception elements can be provided. If those are clicked - return void
 * @param {element} ref Reference to the element to ignore
 * @param {function} handler Callback to executes if the user clicks outside ref/exceptions
 * @param {array} exceptions An array of elements that should be exceptions and ignored if clicked
 * @return {undefined} Nothing is returned  - the callback is executed or not - then return undefined.
 */
export const useOnClickOutside = (ref, handler, exceptions = []) => {
  useEffect(
    () => {
      const listener = (event) => {
        // Do nothing if clicking ref's element or descendent elements
        const clickedExceptionEl = exceptions.some(el => el.current.contains(event.target));
        if (!ref.current || (ref.current.contains(event.target) || clickedExceptionEl)) {
          return;
        }
        handler(event);
        event.preventDefault();
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener, { passive: false });
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler],
  );
}